module.exports = __webpack_public_path__ + "static/media/vf_mshirts_core.ea5fd60e.svg";